import * as React from 'react'
import styles from './index.module.css'

type Props = {
  height?: number
  children?: React.ReactNode
}

const NoData = (props: Props): React.ReactElement<'div'> => (
  <div
    className={styles.noData}
    style={{
      height: props.height,
    }}
  >
    {props.children ?? 'Sorry! There’s no activity available for this period.'}
  </div>
)

export default NoData
